module.exports = __webpack_public_path__ + "img/e_3_16_g.0fad47fb.png";